import { Button, Textarea, TextInput } from '@mantine/core';
import { useForm, zodResolver } from '@mantine/form';
import { notifications } from '@mantine/notifications';

import { useDirtyForm } from '@/shared/hooks/use-dirty-form';
import { useCurrentProject } from '@/shared/projects/project-path';

import { useCreateAuthorMutation } from '../model/create-author-page.cases';
import { CREATE_AUTHOR_SCHEMA } from '../model/create-author-page.schemas';
import styles from './create-author-page.module.scss';

export const CreateAuthorPage = () => {
  const form = useForm({
    initialValues: {
      name: '',
      description: '',
      birthday: '',
    },
    validate: zodResolver(CREATE_AUTHOR_SCHEMA),
  });
  const createAuthorMutation = useCreateAuthorMutation();
  const project = useCurrentProject();
  useDirtyForm(form.isDirty());

  async function handleSubmit(values: {
    name: string;
    description: string | null;
    birthday: string;
  }) {
    console.log(values);
    createAuthorMutation
      .mutateAsync({
        name: values.name,
        description: values.description,
        birthday: values.birthday || undefined,
      })
      .then((result) => {
        notifications.show({
          message: 'Автор создан',
          color: 'green',
        });

        return result;
      })
      .catch(() => {
        notifications.show({
          message: 'Не удалось создать автора',
          color: 'red',
        });
      });
  }

  return (
    <form className={styles.container} onSubmit={form.onSubmit(handleSubmit)}>
      <p className={styles.title}>Создание автора</p>
      <TextInput
        placeholder="Имя автора"
        label="Имя"
        className={styles.nameInput}
        {...form.getInputProps('name')}
      />
      <Textarea
        placeholder="Описание автора"
        label="Описание"
        className={styles.descriptionInput}
        {...form.getInputProps('description')}
      />
      {project === 'kitaba' && (
        <TextInput
          type="date"
          label="Дата рождения"
          {...form.getInputProps('birthday')}
        />
      )}
      <div className={styles.actions}>
        <Button type="submit">Сохранить</Button>
        <Button variant="light" onClick={() => history.back()}>
          Отменить
        </Button>
      </div>
    </form>
  );
};
